const initializeVideoTransitionForUmbraco = () => {


    let configuration = null;

    const createConfiguration = (transitionVideos) => {


        // create the video definitions for the transition manager.
        const videos = transitionvideos.data.videos.map(o => {
            return {
                id: o.videoId,
                src: `${config.MEDIA_DIRECTORY}${o.videoSrc.src}`,
                poster: `${config.MEDIA_DIRECTORY}${o.videoPoster.src}`
            }
        });

        const posterAssets = [];
        // create poster assets for the preloader.
        videos.forEach(v => {
            posterAssets.push({ id: v.poster, url: v.poster })
        })


        // Build the transition definition
        const transitions = app.data.custom.find(o => o.type === "transitions").data.transitionDefinitions.map(o => {
            /** @param route Object <{any?:string, to?:string, from?:string}>*/
            let route = {};
            o.trigger.forEach(t => {
                route[t.routeOrigin] = t.routeEquals;
            })
            /** @param video Object <{any?:string, in?:string, out?:string >*/
            let video = {}
            o.videos.forEach(v => {
                video[v.origin] = v.videoId
            })
            return {
                route,
                video
            }
        })

        const VideoTransitionConfig = { useImageCacheForPosterImages: true, videos, transitions }
        return {
            posterAssets, VideoTransitionConfig
        }
    }

    return {


        transitionDefinitions() {
            return app.data.custom.find(o => o.type === "transitionVideos");
        },

        hasTransitionDefinitions() {
            return this.transitionDefinitions() !== undefined;
        },

        initialize(app) {
            var transitionVideos = this.transitionDefinitions();
            if (!transitionVideos) return;
            configuration = createConfiguration(transitionVideos);
            console.log("create configuration ", configuration)
            app.videoTransitionManager = new VideoTransitionManager(configuration.VideoTransitionConfig);

        },

        get posters() {
            return this.transitionDefinitions() ? configuration.posterAssets : [];
        },

        start(app, container) {

            if (!this.hasTransitionDefinitions()) return;
            app.videoTransitionManager.init(app, container);
        }

    }

}